/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RequisitionTypeWithRelations } from './requisitionTypeWithRelations';
import { BusinessUnitWithRelations } from './businessUnitWithRelations';
import { SubstitutionTypeWithRelations } from './substitutionTypeWithRelations';
import { CompanyWithRelations } from './companyWithRelations';
import { ContractTypeWithRelations } from './contractTypeWithRelations';
import { JobPositionWithRelations } from './jobPositionWithRelations';
import { VacancyStatusWithRelations } from './vacancyStatusWithRelations';
import { PersonalRequisitionWithRelations } from './personalRequisitionWithRelations';
import { PlaceTypeWithRelations } from './placeTypeWithRelations';
import { UserWithRelations } from './userWithRelations';
import { AuthorizedSalaryWithRelations } from './authorizedSalaryWithRelations';


/**
 * (tsType: VacancyWithRelations, schemaOptions: { includeRelations: true })
 */
export interface VacancyWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    jobName: string;
    city: string;
    areaUnitBusiness?: string;
    employeeReplace?: string;
    ammount?: number;
    compensationScheme?: number;
    duration?: string;
    interviewProcess?: number;
    reason?: string;
    comments?: string;
    authorizationDate?: string;
    authorized?: boolean;
    justification?: string;
    candidate?: string;
    deliveryDate?: string;
    dateInitial?: string;
    code?: string;
    level?: string;
    dateCancellation?: string;
    dateDeclined?: string;
    dateSignature?: string;
    dateReactivated?: string;
    companyId?: string;
    requiredById?: number;
    authorizedById?: number;
    vacancyStatusId?: string;
    requisitionPersonalId?: string;
    jobPositionId?: string;
    requisitionTypeId?: string;
    contractTypeId?: string;
    substitutionTypeId?: string;
    placeTypeId?: string;
    authorizedSalaryId?: string;
    businessUnitId?: string;
    company?: CompanyWithRelations;
    requiredBy?: UserWithRelations;
    authorizedBy?: UserWithRelations;
    vacancyStatus?: VacancyStatusWithRelations;
    personalRequisition?: PersonalRequisitionWithRelations;
    jobPosition?: JobPositionWithRelations;
    requisitionType?: RequisitionTypeWithRelations;
    contractType?: ContractTypeWithRelations;
    substitutionType?: SubstitutionTypeWithRelations;
    placeType?: PlaceTypeWithRelations;
    authorizedSalaryType?: AuthorizedSalaryWithRelations;
    businessUnit?: BusinessUnitWithRelations;
}

